import { Component } from '@angular/core';
import { IonicPage, ToastController, PopoverController, Popover, LoadingController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { PaginaBasica } from '../../models/PaginaBase';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { Proxy } from '../../services/proxy/proxy.service';
import { iConfiguracion } from '../../models/basePage';
import { Observable } from "rxjs";

import * as mod from '../../models/otrosAuxiliares';
import { OtrosAuxiliaresAmonestacionService, OtrosAuxiliaresService } from '../../services/api/otrosauxiliares.service';

@IonicPage()
@Component({
  selector: 'page-resumen',
  templateUrl: 'resumen.html',
})
export class ResumenPage extends PaginaBasica {

  //#region Propiedades de la página
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public cambios: Proxy.ListaPrCambios;
  public goles: Proxy.ListaPrGoles;
  public amonestaciones: Proxy.ListaPrAmonestaciones;
  public codigos: Proxy.ListaPrCodigoAmonestacion;
  public incidencias: Proxy.ListaPrAmonestaciones;

  public pruebas: boolean = false;
  //#endregion

  // #region Propiedades de los otros auxiliares
  public auxiliares: Proxy.ListaPrPersonaAlineable;
  public listaParticipantes$: Observable<mod.ActasParticipacionOtrosAuxiliares[]>;
  // #endregion

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController,
    public OtrosAuxiliaresService: OtrosAuxiliaresService,
    public otrosAuxiliaresAmonestacionService: OtrosAuxiliaresAmonestacionService
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: RESUMEN ---');

    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    // Definición de observables
    this.listaParticipantes$ = this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares$;

    this.auxiliares = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );

    // Licencias y participantes, ..
    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    // ...cambios, ...
    this.cambios = new Proxy.ListaPrCambios(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    // ... goles, ...
    this.goles = new Proxy.ListaPrGoles(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    // ... y amonestaciones e incidencias, ...
    this.amonestaciones = new Proxy.ListaPrAmonestaciones(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.codigos = new Proxy.ListaPrCodigoAmonestacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.incidencias = new Proxy.ListaPrAmonestaciones(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    this.MostrarOcultarCarga(false, "cargando datos");

    // Carga de los participantes establecidos
    this.OtrosAuxiliaresService.Lista(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo)
      .subscribe({
        next: (resultado: mod.ActasParticipacionOtrosAuxiliares[]) => {
          // Una vez cargada la lista de otros auxiliares, se procesa la carga de todos los datos.
          // Es necesario que se realice la carga antes, porque se va a utilizar para incluir a los otros
          // auxiliares alineados en la lista 'auxiliares.lista'.

          this.Persistentes.GetConfiguracion()
            .then((resultado: iConfiguracion) => {
              this.pruebas = resultado.pruebas;
              return this.participantes.CargarListaParticipacion();
            })
            .then((resultado: boolean) => {
              return this.licencias.ObtenerAlineables(true, true, true);
            })
            .then((resultado: boolean) => {
              this.auxiliares.lista = [];

              try {
                // Recorrer la lista de licencias obtenidas, para filtrarla y guardar solo los auxiliares en la varible 'auxiliares'
                if (this.licencias != null && this.licencias.lista != null) {
                  this.licencias.lista.forEach((valor: Proxy.PrPersonaAlineable) => {
                    let nombreTipo: string = valor.tipoLicencia.toUpperCase();
                    if (nombreTipo.indexOf("MONITOR") < 0 &&
                      (nombreTipo.indexOf("ENTRENADOR") < 0 ||
                        (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("AUXILIAR") >= 0) ||
                        (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("SEGUNDO") >= 0) ||
                        (nombreTipo.indexOf("ENTRENADOR") >= 0 && nombreTipo.indexOf("PRACTICAS") >= 0)) &&
                      (nombreTipo.indexOf("DELEGADO") < 0) &&
                      this.EstaAlineado(valor.identificador)) {
                      // Solamente se añadirán en la lista de auxiliares, aquellos que cumplan con los requisitos y estén marcados como alineados.
                      this.auxiliares.lista.push(valor);
                    }
                  });
                }
              }
              catch (e) {
                console.error(e);
              }

              return this.cambios.CargarCambios();
            })
            .then((resultado: boolean) => {
              if (this.designacion.ventanasCambios) {
                // Ordenación de los cambios según las ventanas
                this.cambios.lista = this.cambios.lista.sort((a: Proxy.PrCambios, b: Proxy.PrCambios) => {
                  if (a.descanso || a.ventana < b.ventana) {
                    return -1;
                  } else {
                    return 1;
                  }
                });
              }

              return this.goles.CargarGoles();
            })
            .then((resultado: boolean) => {
              console.log("Goles");
              console.log(this.goles.lista);
              return this.amonestaciones.CargarAmonestaciones(false);
            })
            .then((resultado: boolean) => {
              return this.codigos.CargarCodigosAmonestacion();
            })
            .then((resultado: boolean) => {
              return this.incidencias.CargarAmonestaciones(true);
            })
            .then((resultado: boolean) => {
              this.MostrarOcultarCarga();
            })
            .catch(error => this.Error(error, "ERROR al obtener los datos completos de la designación."));

          this.otrosAuxiliaresAmonestacionService.listaPorDesignacionYEquipo(
              this.designacion.urlApi,
              this.designacion.idDesignacion,
              this.idEquipo
          ).subscribe();
        }
      });
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event
    });
  }

  /**
   * Comprueba si la la persona está alineada
   * @param dni DNI de la persona
   * @returns Indica si se está alineado
   */
  EstaAlineado(dni: string): boolean {
    if (this.OtrosAuxiliaresService != null &&
      this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares != null &&
      this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares.length > 0) {
      return this.OtrosAuxiliaresService.listaParticipacionOtrosAuxiliares.find(m => m.identificador.toUpperCase().trim() == dni.toUpperCase().trim()) != null
        ? true
        : false;
    } else {
      return false;
    }
  }

  /**
   * Establece la lista de los jugadores del equipo, según los alineados
   */
  public Inicializacion(): void {
    // if (this.designacion != null && this.designacion.partido != null) {
    //   this.jugadoresLocal = [];
    //   this.jugadoresVisitante = [];
    //   this.cambiosLocal = [];
    //   this.cambiosVisitante = [];
    //   this.amonestacionesLocal = [];
    //   this.amonestacionesVisitante = [];
    //   this.incidenciasLocal = [];
    //   this.indicenciasVisitante = [];

    //   // Alineados
    //   this.designacion.partido.alineadosLocal.forEach((valor: Alineados, i: number) => {
    //     if (!valor.esAuxiliar && !valor.esEntrenador && this.DorsalPorLicencia(valor.id_Licencia, true) > 0) {
    //       this.jugadoresLocal.push(valor);
    //     }
    //   });
    //   this.designacion.partido.alineadosVisitante.forEach((valor: Alineados, i: number) => {
    //     if (!valor.esAuxiliar && !valor.esEntrenador && this.DorsalPorLicencia(valor.id_Licencia, false) > 0) {
    //       this.jugadoresVisitante.push(valor);
    //     }
    //   });

    //   // Cambios
    //   this.designacion.partido.listaCambios.forEach((valor: Designaciones_Cambios, i: number) => {
    //     if (valor.esLocal) {
    //       this.cambiosLocal.push(valor);
    //     }
    //     else {
    //       this.cambiosVisitante.push(valor);
    //     }
    //   });

    //   // Amonestaciones e incidencias
    //   this.designacion.partido.listaAmonestaciones.forEach((valor: Designaciones_Amonestaciones, i: number) => {
    //     if (valor.esLocal) {
    //       if (valor.esIncidencia) {
    //         this.incidenciasLocal.push(valor);
    //       }
    //       else {
    //         this.amonestacionesLocal.push(valor);
    //       }
    //     }
    //     else {
    //       if (valor.esIncidencia) {
    //         this.indicenciasVisitante.push(valor);
    //       }
    //       else {
    //         this.amonestacionesVisitante.push(valor);
    //       }
    //     }
    //   });
    // }
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/resumen/resumen.ts